/**
 * コモンクラス
 * @constructor
 */
 class Common {
  constructor() {
    this.init();
  }
  /**
   * コモン
   */
  init() {
    // alert('Common.jsが読み込まれました');
  }

}

export default Common;
